import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlayerTypeLinksService, Configuration } from '../../api-client';

@Injectable({ providedIn: 'root' })
export class PlayerTypeLinkService extends PlayerTypeLinksService {
    constructor(httpClient: HttpClient, configuration: Configuration) {
        super(httpClient, configuration.basePath!, configuration);
    }

    remove(linkId: number): Observable<void> {
        return super.removePlayerTypeLinkEndpoint(linkId);
    }
}
